export const CONTAINER_DEFAULT_MIN_HEIGHT = 520;
export const REFER_CONTENT_AREA_HEIGHT = 435;
export const PADDING_TOP_IN_MAX_STATUS = '8';
export const PADDING_LEFT_IN_MAX_STATUS = '30';
export const GRID_TREE_SEARCH_INPUT = 'grid-input-for-tab-sequence';
export const TABLE_HEAD_CHECKBOX_CLASS_NAME = 'refer-table-head-checkbox';
